import { Suspense } from "react"

import { Await, useAsyncError, useLoaderData } from "react-router-dom"

import { NeuralNetworkLoader } from "../loading"
import { QueryError } from "../query-error"

const AwaitError: React.FC = () => {
  const error = useAsyncError()

  return <QueryError error={error} />
}

interface LazyLoaderProps {
  fallback?: React.ReactNode
  errorElement?: React.ReactNode
}

export const LazyLoader: React.FC<LazyLoaderProps> = ({
  fallback = <NeuralNetworkLoader />,
  errorElement = <AwaitError />
}) => {
  const { component } = useLoaderData<{ component: Promise<React.ComponentType<object>> }>()

  return (
    <Suspense fallback={fallback}>
      <Await
        resolve={component}
        errorElement={errorElement}>
        {ResolvedComponent => <ResolvedComponent />}
      </Await>
    </Suspense>
  )
}
